import '../styles.scss'

import { useTranslation } from 'react-i18next'

import FormatPrice from '@/components/FormatPrice'

const OrderSummary = (props) => {
  const {
    salesOrderNumber,
    currencyUnit,
    cartTotal,
    includingVAT,
    vat,
    cartTotalVAT,
  } = props
  const { t } = useTranslation()

  return (
    <div className="order-confirm__main__middle">
      <div className="order-confirm__main__middle__title">
        {t('checkout.confirmOrder.orderSummary')}
      </div>
      <div>
        {t('checkout.confirmOrder.orderNumber')}
        :&nbsp;
        <span data-testid="salesOrderNumber">{salesOrderNumber}</span>
      </div>

      <div>
        {t('checkout.confirmOrder.total')}:{' '}
        <FormatPrice currencyUnit={currencyUnit} price={cartTotal} />
      </div>
      {includingVAT && (
        <div>
          <div>
            {t('vat')}: <FormatPrice currencyUnit={currencyUnit} price={vat} />
          </div>

          <div>
            {t('totalWithVat')}: <FormatPrice currencyUnit={currencyUnit} price={cartTotalVAT} />
          </div>
        </div>
      )}
      <div>
        {t('checkout.confirmOrder.paymentMethod')}: {t('invoice')}
      </div>
    </div>
  )
}

export default OrderSummary
